export const routes = (parentName) => {
  return [
    {
      path: "lunch",
      component: () => import("./Index.vue"),
      children: [
        {
          path: "",
          name: `${parentName}-Lunch`,
          component: () => import("./List.vue"),
          props: (route) => ({
            step: route.query.step,
          }),
        },
        {
          path: "",
          name: `${parentName}-Lunch-List`,
          component: () => import("./List.vue"),
          props: (route) => ({
            step: route.query.step,
          }),
        },
        {
          path: "special",
          name: `${parentName}-Lunch-List-Special`,
          component: () => import("./ListSpecial.vue"),
          props: (route) => ({
            step: route.query.step,
          }),
        },
        {
          path: "new",
          name: `${parentName}-Lunch-New`,
          component: () => import("./Upsert.vue"),
        },

        {
          path: ":id/edit",
          name: parentName + "-" + "Lunch-Edit",
          component: () => import("./Upsert.vue"),
        },
      ],
    },
  ];
};
